import type { InputHTMLAttributes, ReactNode } from "react";

export type InputSize = "sm" | "md" | "lg";

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  size?: InputSize;
  icon?: ReactNode;
  wrapperClassName?: string;
};

const sizeClasses: Record<InputSize, string> = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-3.5 py-2 text-sm",
  lg: "px-4 py-3 text-base",
};

const iconPaddingClasses: Record<InputSize, string> = {
  sm: "pl-8",
  md: "pl-9",
  lg: "pl-10",
};

export const Input = ({
  size = "md",
  icon,
  className = "",
  wrapperClassName = "",
  disabled,
  ...rest
}: InputProps) => (
  <div className={`relative flex items-center ${wrapperClassName}`}>
    {icon && (
      <div className="absolute left-3 pointer-events-none text-gray-400 flex items-center justify-center">
        {icon}
      </div>
    )}
    <input
      dir="auto"
      disabled={disabled}
      className={`w-full bg-[#1a1a1a] border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-purple-500 transition disabled:opacity-50 ${
        sizeClasses[size]
      } ${icon ? iconPaddingClasses[size] : ""} ${className}`}
      {...rest}
    />
  </div>
);
